package medicalRecord.containers


import com.jingfangpai.api.clients.MedicalRecordApiClient
import medicalRecord.components.MedicalRecordEdit
import react.*
import react.dom.div
import setTitle

external interface MedicalRecordEditPageProps : RProps {
    var id:String
}

data class MedicalRecordEditPageContextData(
    var save:(medicalRecord:com.jingfangpai.common.orm.mapping.MedicalRecord, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecord>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getById:(id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.MedicalRecord>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
)

val MedicalRecordEditPageContext = createContext(MedicalRecordEditPageContextData(MedicalRecordApiClient::save,MedicalRecordApiClient::getDetail))

val MedicalRecordEditPageProvider = functionalComponent<MedicalRecordEditPageProps> { props ->

    setTitle("医案编辑")

    fun placeHolderFunction(param: String) {
        console.log("doing something with param")
    }

    useEffectOnce { }

    MedicalRecordEditPageContext.Provider(MedicalRecordEditPageContextData(MedicalRecordApiClient::save,MedicalRecordApiClient::getDetail)) {
        div("MedicalRecordEditPage-page") {
            child(MedicalRecordEdit) {
                attrs{
                    id = props.id
                }
            }
        }
    }
}
